(() => {
  if(window.inksakeChronographV2Loaded)return;
  window.inksakeChronographV2Loaded=true;
  const metrics={
  "font_sha256": "a4c5bc453ca281d90ea079e596da7ae0dfeb5777497c29ec254e76d97ff6f890",
  "units_per_em": 2048,
  "kerning": false,
  "glyphs": {
    "A": {
      "advance": 1585,
      "bounds": [
        10,
        0,
        1575,
        1493
      ]
    },
    "B": {
      "advance": 1561,
      "bounds": [
        188,
        0,
        1417,
        1493
      ]
    },
    "C": {
      "advance": 1503,
      "bounds": [
        102,
        -29,
        1372,
        1520
      ]
    },
    "D": {
      "advance": 1700,
      "bounds": [
        188,
        0,
        1593,
        1493
      ]
    },
    "E": {
      "advance": 1399,
      "bounds": [
        188,
        0,
        1249,
        1493
      ]
    },
    "F": {
      "advance": 1399,
      "bounds": [
        188,
        0,
        1227,
        1493
      ]
    },
    "G": {
      "advance": 1681,
      "bounds": [
        102,
        -29,
        1530,
        1520
      ]
    },
    "H": {
      "advance": 1714,
      "bounds": [
        188,
        0,
        1526,
        1493
      ]
    },
    "I": {
      "advance": 762,
      "bounds": [
        188,
        0,
        573,
        1493
      ]
    },
    "J": {
      "advance": 762,
      "bounds": [
        -115,
        -410,
        573,
        1493
      ]
    },
    "K": {
      "advance": 1587,
      "bounds": [
        188,
        0,
        1649,
        1493
      ]
    },
    "L": {
      "advance": 1305,
      "bounds": [
        188,
        0,
        1249,
        1493
      ]
    },
    "M": {
      "advance": 2038,
      "bounds": [
        188,
        0,
        1849,
        1493
      ]
    },
    "N": {
      "advance": 1714,
      "bounds": [
        188,
        0,
        1526,
        1493
      ]
    },
    "O": {
      "advance": 1741,
      "bounds": [
        102,
        -29,
        1638,
        1520
      ]
    },
    "P": {
      "advance": 1501,
      "bounds": [
        188,
        0,
        1417,
        1493
      ]
    },
    "Q": {
      "advance": 1741,
      "bounds": [
        102,
        -299,
        1638,
        1520
      ]
    },
    "R": {
      "advance": 1577,
      "bounds": [
        188,
        0,
        1536,
        1493
      ]
    },
    "S": {
      "advance": 1475,
      "bounds": [
        147,
        -29,
        1325,
        1520
      ]
    },
    "T": {
      "advance": 1397,
      "bounds": [
        10,
        0,
        1386,
        1493
      ]
    },
    "U": {
      "advance": 1663,
      "bounds": [
        188,
        -29,
        1475,
        1493
      ]
    },
    "V": {
      "advance": 1585,
      "bounds": [
        10,
        0,
        1575,
        1493
      ]
    },
    "W": {
      "advance": 2259,
      "bounds": [
        61,
        0,
        2195,
        1493
      ]
    },
    "X": {
      "advance": 1579,
      "bounds": [
        39,
        0,
        1538,
        1493
      ]
    },
    "Y": {
      "advance": 1483,
      "bounds": [
        -20,
        0,
        1503,
        1493
      ]
    },
    "Z": {
      "advance": 1485,
      "bounds": [
        92,
        0,
        1393,
        1493
      ]
    },
    "0": {
      "advance": 1425,
      "bounds": [
        98,
        -29,
        1327,
        1520
      ]
    },
    "1": {
      "advance": 1425,
      "bounds": [
        231,
        0,
        1284,
        1493
      ]
    },
    "2": {
      "advance": 1425,
      "bounds": [
        162,
        0,
        1247,
        1520
      ]
    },
    "3": {
      "advance": 1425,
      "bounds": [
        137,
        -29,
        1262,
        1520
      ]
    },
    "4": {
      "advance": 1425,
      "bounds": [
        92,
        0,
        1331,
        1493
      ]
    },
    "5": {
      "advance": 1425,
      "bounds": [
        158,
        -29,
        1282,
        1493
      ]
    },
    "6": {
      "advance": 1425,
      "bounds": [
        127,
        -29,
        1315,
        1518
      ]
    },
    "7": {
      "advance": 1425,
      "bounds": [
        137,
        0,
        1262,
        1493
      ]
    },
    "8": {
      "advance": 1425,
      "bounds": [
        125,
        -29,
        1298,
        1520
      ]
    },
    "9": {
      "advance": 1425,
      "bounds": [
        106,
        -29,
        1294,
        1518
      ]
    },
    " ": {
      "advance": 713,
      "bounds": null
    },
    "'": {
      "advance": 627,
      "bounds": [
        195,
        938,
        432,
        1493
      ]
    },
    ",": {
      "advance": 778,
      "bounds": [
        109,
        -291,
        569,
        387
      ]
    },
    ".": {
      "advance": 778,
      "bounds": [
        209,
        0,
        569,
        387
      ]
    },
    "-": {
      "advance": 850,
      "bounds": [
        111,
        444,
        739,
        735
      ]
    },
    "&": {
      "advance": 1786,
      "bounds": [
        123,
        -29,
        1700,
        1520
      ]
    }
  }
};
  const choices=['SO PROUD OF YOU','ALWAYS WITH YOU',"YOU'VE GOT THIS",'TO NEW BEGINNINGS'];
  function measure(text,size,baseline) {
    let x=0,left=Infinity,right=-Infinity,top=Infinity,bottom=-Infinity;
    const scale=size/metrics.units_per_em;
    for(const c of text) {
      const glyph=metrics.glyphs[c]; if(!glyph) return null;
      const b=glyph.bounds;
      if(b) {left=Math.min(left,x+b[0]*scale);right=Math.max(right,x+b[2]*scale);top=Math.min(top,baseline-b[3]*scale);bottom=Math.max(bottom,baseline-b[1]*scale);}
      x+=glyph.advance*scale;
    }
    if(!Number.isFinite(left))return null;
    const width=right-left,radius=Math.max(Math.hypot(width/2,top-500),Math.hypot(width/2,bottom-500));
    return {width,radius,fits:radius<=432,size,baseline};
  }
  function line(raw,field) {
    if(typeof raw!=='string' || !['recipient','signoff'].includes(field))return null;
    const text=raw.replace(/^ +| +$/g,'').replace(/[a-z]/g,c=>String.fromCharCode(c.charCodeAt(0)-32));
    if(text.length<1 || text.length>12 || [...text].some(c=>!Object.hasOwn(metrics.glyphs,c)) || !/[A-Z0-9]/.test(text))return null;
    const [size,baseline]=field==='recipient'?[100,415]:[65,635];
    const original=measure(text,size,baseline),chosen=original.fits?original:measure(text,55,baseline);
    return chosen?.fits?{text,...chosen,fallback:chosen.size===55}:null;
  }
  function validate(form,normalize=false) {
    const group=form.querySelector('[data-inksake-chronograph-text]'); if(!group)return true;
    const ready=group.querySelector('[data-inksake-cw-ready]'); ready.value='';
    const fields=[group.querySelector('[data-inksake-cw-line="recipient"]'),group.querySelector('[data-inksake-cw-line="signoff"]')];
    const dedication=group.querySelector('[data-inksake-cw-dedication]');
    const allowed=group.dataset.inksakeVariants.trim().split(/\s+/);
    if(group.dataset.inksakeValidConfig!=='true' || !allowed.includes(form.elements.namedItem('id')?.value) || fields.some(f=>!f) || !dedication) {ready.setCustomValidity(group.dataset.configError);return false;}
    let valid=true;
    for(const field of fields) {
      const value=line(field.value,field.dataset.inksakeCwLine);
      if(value && normalize)field.value=value.text;
      field.setCustomValidity(value?'':field.dataset.textError);if(!value)valid=false;
    }
    const dedicationFit=choices.includes(dedication.value) && measure(dedication.value,62,525)?.fits;
    dedication.setCustomValidity(dedicationFit?'':dedication.dataset.choiceError); if(!dedicationFit)valid=false;
    ready.setCustomValidity('');ready.value='validated';return valid;
  }
  document.addEventListener('paste',event=>{
    const field=event.target;if(!(field instanceof HTMLInputElement) || !field.matches('[data-inksake-cw-line]'))return;
    const raw=event.clipboardData?.getData('text/plain');if(typeof raw!=='string')return;
    const candidate=field.value.slice(0,field.selectionStart??0)+raw+field.value.slice(field.selectionEnd??field.value.length);
    const value=line(candidate,field.dataset.inksakeCwLine);event.preventDefault();
    if(!value){field.setCustomValidity(field.dataset.textError);return;}
    field.value=value.text;field.dispatchEvent(new Event('input',{bubbles:true}));
  });
  document.addEventListener('beforeinput',event=>{
    const field=event.target;if(!(field instanceof HTMLInputElement) || !field.matches('[data-inksake-cw-line]') || typeof event.data!=='string')return;
    if([...event.data].some(c=>!/[a-z]/.test(c) && !Object.hasOwn(metrics.glyphs,c))){event.preventDefault();field.setCustomValidity(field.dataset.textError);}
  });
  document.addEventListener('input',event=>{const form=event.target.closest('form');if(form)validate(form);});
  document.addEventListener('change',event=>{const form=event.target.closest('form');if(form)validate(form,true);});
  document.addEventListener('submit',event=>{
    const form=event.target;if(!(form instanceof HTMLFormElement) || !form.querySelector('[data-inksake-chronograph-text]'))return;
    if(!validate(form,true) || !form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('formdata',event=>{
    const form=event.target;if(!(form instanceof HTMLFormElement) || !form.querySelector('[data-inksake-chronograph-text]'))return;
    if(validate(form,true))for(const field of form.querySelectorAll('[data-inksake-cw-line]'))event.formData.set(field.name,field.value);
  });
  document.querySelectorAll('[data-inksake-chronograph-text]').forEach(group=>{const form=group.closest('form');if(form)validate(form);});
})();
